// extracted by mini-css-extract-plugin
module.exports = {"icon-warning":"icon-warning___3zzZq","title":"title___3OdiL"};